var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFolderGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9954 4.5C18.9954 4.22386 18.7716 4 18.4954 4C18.2193 4 17.9954 4.22386 17.9954 4.5V5.92486H16.4908C16.2147 5.92486 15.9908 6.14872 15.9908 6.42486C15.9908 6.701 16.2147 6.92486 16.4908 6.92486H17.9954V8.34972C17.9954 8.53909 18.1007 8.70388 18.256 8.78874H10.1323V7.04426H4.00012V10.5332H20.3525V8.78874H18.7349C18.8902 8.70388 18.9954 8.53909 18.9954 8.34972V6.92486H20.5001C20.7762 6.92486 21.0001 6.701 21.0001 6.42486C21.0001 6.14872 20.7762 5.92486 20.5001 5.92486H18.9954V4.5ZM4.00012 20.1278V12.2777H20.3525V20.1278C20.3525 20.6163 19.9028 21.0001 19.3305 21.0001H5.02214C4.44981 21.0001 4.00012 20.6163 4.00012 20.1278Z",
    fill: "#7D94AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFolderGray);
export default __webpack_public_path__ + "static/media/add-folder-gray.ffa247aca12972101d44c30392f9e8b6.svg";
export { ForwardRef as ReactComponent };